export default __webpack_public_path__ + "/SMALL_CROWD_APPLAUSE-Yannick_Lemieux-1268806408.mp3";